<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox filter">
            <div class="d-flex flex-row justify-content-between">
                <div><h2 class="page-title">Leadtime</h2></div>
                <div class="d-flex flex-row justify-content-end">
                    <template v-if="user.type !== 'ADMIN_EKSPEDISI'">
                        <div class="mr-3">
                            <div
                                class="custom-control custom-switch"
                                style="min-width: 150px"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="bongkarIntransitSwitch"
                                    v-model="isIntransit"
                                />
                                <label
                                    class="custom-control-label"
                                    for="bongkarIntransitSwitch"
                                    >{{
                                        isIntransit
                                            ? "Intransit"
                                            : "Bongkar Muat"
                                    }}</label
                                >
                            </div>
                        </div>
                        <div class="mr-3">
                            <div v-if="!isIntransit">
                                <MultiSelect
                                    v-model="selected.byDateMonth"
                                    :options="
                                        options.byDateMonth.map((x) => x.value)
                                    "
                                    :custom-label="
                                        (opt) =>
                                            options.byDateMonth.find(
                                                (x) => x.value == opt
                                            ).title
                                    "
                                    :deselect-label="''"
                                    :allow-empty="false"
                                    placeholder="Date or Month"
                                    class="tms-multiselect"
                                />
                            </div>
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.universalFilter.region"
                                :options="options.region"
                                :deselect-label="''"
                                placeholder="All Regions"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                :options="options.ekspedisi.map((x) => x.id)"
                                :custom-label="
                                    (opt) =>
                                        options.ekspedisi.find(
                                            (x) => x.id == opt
                                        ).kode
                                "
                                placeholder="All Ekspedisi"
                                v-model="filter.universalFilter.ekspedisi"
                                class="tms-multiselect"
                            />
                        </div>
                    </template>
                    <template v-else>
                        <div class="mr-3">
                            <div
                                class="custom-control custom-switch"
                                style="min-width: 150px"
                                :class="isIntransit ? 'ml-5' : ''"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="bongkarIntransitSwitch"
                                    v-model="isIntransit"
                                />
                                <label
                                    class="custom-control-label"
                                    for="bongkarIntransitSwitch"
                                    >{{
                                        isIntransit
                                            ? "Intransit"
                                            : "Bongkar Muat"
                                    }}</label
                                >
                            </div>
                        </div>
                        <div class="mr-3">
                            <div v-if="!isIntransit">
                                <MultiSelect
                                    v-model="selected.byDateMonth"
                                    :options="
                                        options.byDateMonth.map((x) => x.value)
                                    "
                                    :custom-label="
                                        (opt) =>
                                            options.byDateMonth.find(
                                                (x) => x.value == opt
                                            ).title
                                    "
                                    :deselect-label="''"
                                    :allow-empty="false"
                                    placeholder="Date or Month"
                                    class="tms-multiselect"
                                />
                            </div>
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.universalFilter.region"
                                :options="options.region"
                                :deselect-label="''"
                                placeholder="All Regions"
                                class="tms-multiselect"
                            />
                        </div>
                    </template>
                    <div v-if="selected.byDateMonth == 1">
                        <div class="mr-3">
                            <div class="input-group">
                                <flat-pickr
                                    :config="rangePickr"
                                    placeholder="Select Date"
                                    v-model="selected.date"
                                ></flat-pickr>
                                <span
                                    class="input-group-text bg-white"
                                    style="
                                        border-top-left-radius: 0;
                                        border-bottom-left-radius: 0;
                                        border: 0;
                                        box-shadow: 0 0 6px #0000000f;
                                        background-color: #ededed !important;
                                    "
                                >
                                    <i
                                        class="fas fa-calendar"
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="selected.byDateMonth == 2">
                        <div class="mr-3">
                            <MultiSelect
                                v-model="selected.monthYear.month"
                                :options="options.month.map((x) => x.value)"
                                :custom-label="
                                    (opt) =>
                                        options.month.find(
                                            (x) => x.value == opt
                                        ).name
                                "
                                :allow-empty="false"
                                placeholder="Select Month"
                                class="tms-multiselect"
                            />
                        </div>
                    </div>
                    <div v-if="selected.byDateMonth == 2">
                        <div class="mr-3">
                            <MultiSelect
                                v-model="selected.monthYear.year"
                                :options="options.year"
                                :allow-empty="false"
                                placeholder="Select Year"
                                class="tms-multiselect"
                            />
                        </div>
                    </div>
                    <a
                        href=""
                        class="btn"
                        style="margin-right: -1rem !important; padding: 0"
                    >
                        <img
                            src="@/assets/img/notification.svg"
                            alt=""
                            style="display: none"
                        />
                    </a>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- In-Transit Start -->
        <div class="row" v-if="isIntransit">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div
                        class="mb-3"
                        style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                        "
                    >
                        <h5 class="mr-4 mb-0" style="font: normal normal 600 24px/29px Proxima Nova">Report</h5>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <input
                                class="form-control filterInput col-lg-2"
                                type="search"
                                placeholder="Search by Nopol"
                                aria-label="Search"
                                v-model="filter.intransit.nopol"
                                style="border-left: 0"
                            />
                        </div>
                    </div>
                    <vue-universal-table
                        v-if="tableReady"
                        api_url="/api/reports/lead-time-intransit"
                        :indexing="true"
                        :fields="vue_universal_table.intransit.fields"
                        :update="vue_universal_table.intransit.update"
                        :process_data="
                            vue_universal_table.intransit.process_data
                        "
                        :filter="filter.intransit"
                        :disable_limit_per_page="true"
                        :table_striped="false"
                        :limit_per_page="10"
                    ></vue-universal-table>
                </div>
            </div>
        </div>
        <!-- In-Transit End -->

        <!-- Bongkar Muat Start -->
        <!-- Leadtime by region start -->
        <div class="row" v-if="!isIntransit">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">Leadtime</h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Region</h3>
                    </div>
                    <leadtime-region-chart :data="leadtimeRegionData" />
                </div>
            </div>
        </div>
        <!-- Leadtime by region end -->
        <!-- Leadtime by warehouse start -->
        <div class="row" v-if="!isIntransit">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">Leadtime</h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Warehouse</h3>
                    </div>
                    <leadtime-warehouse-chart :data="leadtimeWarehouseData" />
                </div>
            </div>
        </div>
        <!-- Leadtime by warehouse end -->
        <!-- Leadtime by ekspedisi start -->
        <div class="row" v-if="!isIntransit">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">Leadtime</h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Expedition</h3>
                    </div>
                    <leadtime-ekspedisi-chart :data="leadtimeEkspedisiData" />
                </div>
            </div>
        </div>
        <!-- Leadtime by ekspedisi end -->
        <!-- Table Report Start -->
        <div class="row" v-if="!isIntransit">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div
                        class="mb-3"
                        style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                        "
                    >
                        <h5 class="mr-4 mb-0" style="font: normal normal 600 24px/29px Proxima Nova">Report</h5>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <input
                                class="form-control filterInput col-lg-2"
                                type="search"
                                placeholder="Search by Nopol"
                                aria-label="Search"
                                v-model="filter.bongkarMuat.report.nopol"
                                style="border-left: 0"
                            />
                        </div>
                    </div>
                    <vue-universal-table
                        v-if="tableReady"
                        api_url="/api/reports/lead-time-report"
                        :indexing="true"
                        :fields="vue_universal_table.bongkarMuat.report.fields"
                        :update="vue_universal_table.bongkarMuat.report.update"
                        :buttons="
                            vue_universal_table.bongkarMuat.report.buttons
                        "
                        :process_data="
                            vue_universal_table.bongkarMuat.report.process_data
                        "
                        :filter="filter.bongkarMuat.report"
                        :disable_limit_per_page="true"
                        :limit_per_page="10"
                        :table_striped="false"
                    ></vue-universal-table>
                </div>
            </div>
        </div>
        <!-- Table Report End -->

        <!-- Table Detail Report Start -->
        <div class="row" v-if="!isIntransit">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div
                        class="mb-3"
                        style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                        "
                    >
                        <h5 class="elegant--sub-title mr-4 mb-0">
                            Detail Report
                        </h5>
                        <input
                            class="form-control filterInput col-lg-2"
                            type="search"
                            placeholder="Search by Nopol"
                            aria-label="Search"
                            v-model="filter.bongkarMuat.detail.nopol"
                        />
                    </div>
                    <vue-universal-table
                        v-if="tableReady"
                        api_url="/api/reports/lead-time-detail-bongkar"
                        :indexing="true"
                        :fields="vue_universal_table.bongkarMuat.detail.fields"
                        :update="vue_universal_table.bongkarMuat.detail.update"
                        :buttons="
                            vue_universal_table.bongkarMuat.detail.buttons
                        "
                        :process_data="
                            vue_universal_table.bongkarMuat.detail.process_data
                        "
                        :filter="filter.bongkarMuat.detail"
                        :disable_limit_per_page="true"
                        :limit_per_page="10"
                        :table_striped="false"
                        @onSeeDetails="seeDetail"
                    ></vue-universal-table>
                </div>
            </div>
        </div>
        <!-- Table Detail Report End -->
        <!-- Bongkar Muat End -->
    </div>
</template>

<script>
// import qs from 'qs'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import moment from "moment";
import debounce from "debounce";
import qs from 'qs';
import LeadtimeRegionChart from './children/LeadtimeRegionChart';
import LeadtimeWarehouseChart from './children/LeadtimeWarehouseChart';
import LeadtimeEkspedisiChart from './children/LeadtimeEkspedisiChart';
// import planAlokasiChart from './children/PlanAlokasiChart'
// import 'vue-daterange-picker/dist/vue-daterange-picker.css';

export default {
    metaInfo: {
        title: "Leadtime",
    },
    data() {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        let currentDate = moment().format("YYYY-MM-DD");
        let user = this.$store.getters.currentUser;

        console.log('ini user', user);

        return {
            isIntransit: false, //true == in transit, false == bongkar muat
            tableReady: true,
            user,
            leadtimeRegionData: [],
            leadtimeWarehouseData: [],
            leadtimeEkspedisiData: [],
            rangePickr: {
                mode: "range",
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d M Y",
                altInputClass: "form-control input grey-flatpickr",
            },
            selected: {
                byDateMonth: 1, //1 == by date, 2 == by month
                monthYear: {
                    month: parseInt(moment().format("M")),
                    year: moment().format("YYYY"),
                },
                date: `${startDate} to ${currentDate}`,
            },
            options: {
                byDateMonth: [
                    { title: "By Date", value: 1 },
                    { title: "By Month", value: 2 },
                ],
                month: this.$store.getters.getMonth,
                year: this.$store.getters.getYear,
                region: this.$store.getters.getRegion,
                ekspedisi: this.$store.getters.getEkspedisi,
            },

            filter: {
                universalFilter: {
                    start: startDate,
                    end: currentDate,
                    region: null,
                    ekspedisi: null,
                },

                intransit: {
                    nopol: null,
                    region: null,
                    ekspedisi: null,
                    start: startDate,
                    end: currentDate,
                },

                bongkarMuat: {
                    report: {
                        nopol: null,
                        start: startDate,
                        end: currentDate,
                        region: null,
                        ekspedisi: null,
                    },
                    detail: {
                        nopol: null,
                        start: startDate,
                        end: currentDate,
                        region: null,
                        ekspedisi: null,
                    },
                },
            },

            vue_universal_table: {
                intransit: {
                    fields: [
                        {
                            title: "Nopol",
                            variable: "nopol",
                            disable_sort: true,
                        },
                        {
                            title: "Tanggal Muat",
                            variable: "register_muat",
                            disable_sort: true,
                        },
                        {
                            title: "Realisasi Bongkar",
                            variable: "deadline",
                            disable_sort: true,
                        },
                        {
                            title: "Status",
                            variable: "status",
                            disable_sort: true,
                        },
                    ],
                    update: 0
                },

                bongkarMuat: {
                    report: {
                        fields: [
                            { title: "Nopol", variable: "nopol" },
                            {
                                title: "Tanggal Muat",
                                variable: "tanggal",
                                date_format: "DD/MM/YYYY",
                            },
                            {
                                title: "Deadline Tanggal Bongkar",
                                variable: "tanggal_bongkar",
                                date_format: "DD/MM/YYYY",
                            },
                            { title: "Leadtime", variable: "leadtime" },
                            { title: "Status", variable: "status" },
                        ],
                        update: 0,
                        // buttons : [
                        //     {title : "comment", class:"btn btn-secondary fas fa-comment"}
                        // ],
                        process_data: `
for (var i in data) data[i].leadtime = data[i].leadtime + " Days"
`,
                    },
                    detail: {
                        fields: [
                            { title: "Nopol", variable: "nopol" },
                            {
                                title: "Leadtime Unit",
                                variable: "percent_leadtime_unit",
                            },
                            {
                                title: "Avg. Leadtime Unit",
                                variable: "avg_leadtime_unit",
                            },
                            {
                                title: "Leadtime Truck",
                                variable: "percent_leadtime_truck",
                            },
                            {
                                title: "Avg. Leadtime Truck",
                                variable: "avg_leadtime_truck",
                            },
                        ],
                        update: 0,
                        buttons: [
                            {
                                title: "seeDetails",
                                variable: "nopol",
                                class: "btn btn-secondary",
                            },
                        ],
                        process_data: `
for (var i in data) {
data[i].percent_leadtime_unit = data[i].percent_leadtime_unit + "%"
data[i].avg_leadtime_unit = data[i].avg_leadtime_unit + " Days"
data[i].percent_leadtime_truck = data[i].percent_leadtime_truck + "%"
data[i].avg_leadtime_truck = data[i].avg_leadtime_truck + " Days"
}
`,
                    },
                },
            },
        };
    },
    components: {
        LeadtimeRegionChart,
        LeadtimeWarehouseChart,
        LeadtimeEkspedisiChart
        // planAlokasiChart,
    },
    computed: {
        paginatedData() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.apiData
                ? this.apiData.detail.slice(startIndex, endIndex)
                : [];
        },
    },
    watch: {
        isIntransit() {
            this.tableReady = false;
            this.resetDefaultDate();
            this.selected.byDateMonth = 1;

            setTimeout(() => {
                this.tableReady = true;
            }, 1);
        },
        "selected.monthYear": {
            deep: true,
            handler() {
                var selectedDate = moment().set({
                    year: this.selected.monthYear.year,
                    month: this.selected.monthYear.month - 1,
                });
                this.selected.date = `${selectedDate
                    .startOf("month")
                    .format("YYYY-MM-DD")} to ${selectedDate
                    .endOf("month")
                    .format("YYYY-MM-DD")}`;
            },
        },
        "selected.date"() {
            let split = this.selected.date.split(" to ");
            this.filter.universalFilter.start = split[0];
            this.filter.universalFilter.end =
                split.length > 1 ? split[1] : split[0];
            this.filter.intransit.start = split[0];
            this.filter.intransit.end = split.length > 1 ? split[1] : split[0];
            this.filter.bongkarMuat.report.start = split[0];
            this.filter.bongkarMuat.report.end =
                split.length > 1 ? split[1] : split[0];
            this.filter.bongkarMuat.detail.start = split[0];
            this.filter.bongkarMuat.detail.end =
                split.length > 1 ? split[1] : split[0];
        },

        "filter.intransit": {
            deep: true,
            handler() {
                if (!this.isIntransit) return;
                this.updateIntransit();
            },
        },
        "filter.bongkarMuat.report": {
            deep: true,
            handler() {
                if (this.isIntransit) return;
                this.updateBongkarMuatReport();
            },
        },
        "filter.bongkarMuat.detail": {
            deep: true,
            handler() {
                if (this.isIntransit) return;
                this.updateBongkarMuatDetail();
            },
        },

        "filter.universalFilter": {
            deep: true,
            handler() {
                //Loop everything in the filter above
                for (var i in this.filter.universalFilter) {
                    //In Transit does not have date filter
                    // if ((i == 'start' || i == 'end') && this.isIntransit) continue;

                    this.filter.intransit[i] = this.filter.universalFilter[i];
                    this.filter.bongkarMuat.report[i] =
                        this.filter.universalFilter[i];
                    this.filter.bongkarMuat.detail[i] =
                        this.filter.universalFilter[i];

                    if (this.filter.universalFilter.region === 'All' || this.filter.universalFilter.ekspedisi === 999) {
                        this.filter.universalFilter = {...this.filter.universalFilter, region: null, ekspedisi: null};
                    }
                }
            },
        },

        filter: {
            deep: true,
            immediate: true,
            handler: "delayedFetchData",
        },

        // 'filter.ekspedisi': {
        //     deep: true,
        //     handler () {
        //         this.filter.intransit.ekspedisi = this.filter.ekspedisi
        //         this.filter.bongkarMuat.detail.ekspedisi = this.filter.ekspedisi
        //     }
        // }
    },
    methods: {
        //Will chain reaction to watch
        resetDefaultDate() {
            this.selected.date = `${moment()
                .startOf("month")
                .format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
            this.monthYear = {
                month: moment().format("M"),
                year: moment().format("YYYY"),
            };
        },

        delayedFetchData: debounce(function() {
            this.fetchData();
        }, 1000),
        fetchData() {
            this.$http.get(`/api/reports/lead-time-region?${qs.stringify(
                            this.filter.bongkarMuat.report,
                            { skipNulls: true, arrayFormat: "comma" }
            )}`).then((resp) => {
                this.leadtimeRegionData = resp.data.data;
            })

            this.$http.get(`/api/reports/lead-time-gudang?${qs.stringify(
                            this.filter.bongkarMuat.report,
                            { skipNulls: true, arrayFormat: "comma" }
            )}`).then((resp) => {
                this.leadtimeWarehouseData = resp.data.data;
            })

            this.$http.get(`/api/reports/lead-time-ekspedisi?${qs.stringify(
                            this.filter.bongkarMuat.report,
                            { skipNulls: true, arrayFormat: "comma" }
            )}`).then((resp) => {
                this.leadtimeEkspedisiData = resp.data.data;
            })
        },
        updateIntransit: debounce(function () {
            this.vue_universal_table.intransit.update++;
        }, 1000),
        updateBongkarMuatReport: debounce(function () {
            this.vue_universal_table.bongkarMuat.report.update++;
        }, 1000),
        updateBongkarMuatDetail: debounce(function () {
            this.vue_universal_table.bongkarMuat.detail.update++;
        }, 1000),

        seeDetail(nopol) {
            this.$router.push({
                path: `/dashboard/leadtime/detail/${nopol.replace(/"/g, "")}`,
                query: {
                    start: this.filter.bongkarMuat.detail.start,
                    end: this.filter.bongkarMuat.detail.end,
                },
            });
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.align-middle {
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 27px;
    font-weight: bold;
    margin: 0;
}

.title-wrapper {
    display: flex; /* Use flexbox */
    align-items: baseline; /* Align items along the baseline */
}

.title-space {
    margin-right: 5px; /* Adjust the space by changing the margin */
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: #4d4d4d;
}

.section-title-2 {
    font-size: 15px;
    font-weight: bold;
    margin: 0;
    color: #4d4d4d;
}

.custom-control-label {
    padding: 4px 24px;
}

.custom-control-label::before {
    background-color: #f5b76e;
    width: 48px;
    height: 24px;
    border: 0;
    border-radius: 16px;
    cursor: pointer;
    top: 50%;
    margin-top: -12px;
}

.custom-control-label::after {
    width: 24px;
    height: 24px;
    border-radius: 1000px;
    background-color: #f8f8f8;
    top: 50%;
    margin-top: -12px;
    left: -2.25rem;
    cursor: pointer;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(24px);
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #f5b76e;
    background-color: #f5b76e;
}

.prefix-icon {
    position: absolute;
    right: 15px;
    top: 20px;
    transform: translateY(-50%);
}

.prefix-input .elegant-flatpickr {
    padding-right: 35px;
}
</style>
